// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsSiteForm__wrapper__2ia8M","submitResult":"SettingsSiteForm__submitResult__7Bg8E","actionWrapper":"SettingsSiteForm__actionWrapper__3-Kt-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsSiteForm/SettingsSiteForm.css
// module id = 2927
// module chunks = 0